//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { previewImages } from 'counselor-sdk/lib/modules/system'
import { CatImage } from 'counselor-mobile-ui'
import CatCompleteFlowModal from './cat-complete-flow-modal.vue'
import { REPORT_STATUS_FLOW_CONFIG } from '@/public/config/reportStatus'

export default {
  components: {
    CatImage,
    CatCompleteFlowModal,
  },

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },

    reportApply: {
      type: Boolean,
      default: false,
    },

    reportApplyFlow: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    displayStatus () {
      const { label, fontClassname } = REPORT_STATUS_FLOW_CONFIG[this.info.reportStatus]

      if (this.info.isIotReport) {
        return `<span class="${fontClassname}">${label}</span><span style="color:#9ea7b4;margin-left:2.66667vw">(闸机自动销假)</span>`
      } else if (this.info.isUseAutoReport) {
        return `<span class="${fontClassname}">${label}</span><span style="color:#9ea7b4;margin-left:2.66667vw">(到点自动销假)</span>`
      } else {
        return `<span class="${fontClassname}">${label}</span>`
      }
    },
  },

  methods: {
    preview (imageLists, currentIndex) {
      previewImages({
        imageLists,
        currentIndex,
        disableUrlCodec: true
      })
    },

    viewLocation () {
      if (!this.info.reportLatitude) {
        return
      }

      this.$router.push(`/map/${this.info?.reportLongitude}/${this.info?.reportLatitude}/${encodeURI(this.info?.reportLocation)}`)
    },

    showReportModal () {
      this.$refs.catCompleteFlowModal.show({
        logs: this.info.reportLogs,
        reportApplyFlow: this.reportApplyFlow,
      })
    },
  },
}
